// libs
import React, { memo } from 'react';

interface CircleTickProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

function CircleTick({
  width = 24,
  height = 24,
  fill = '#008945',
  className = '',
}: CircleTickProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12ZM10.6518 13.714L16.8658 7.5L18.2588 8.89298L10.6518 16.5L6 11.8482L7.39298 10.4553L10.6518 13.714Z"
        fill={fill}
      />
    </svg>
  );
}

export default memo(CircleTick);
